import { fetcher } from '@commenda/utils';
import { Country } from '@prisma/client';
import { CAFirmServices, CorporationHasCAFirmAdditionalInfo } from './types';

interface UpdateCAFirmRelationWithCorporationPayload {
  id: number;
  corporationHasCAFirmAdditionalInfo?: CorporationHasCAFirmAdditionalInfo;
}
interface CAFirmUpdateInputProp {
  name?: string;
  description?: string;
  phoneNumber?: string;
  calendlyLink?: string;
  supportedCountries?: Country[];
  corporations?: UpdateCAFirmRelationWithCorporationPayload[];
  additionalInformation?: {
    isOnboardingCompleted?: boolean;
    services?: CAFirmServices[];
  };
}

export default async function updateCAFirm({
  data,
  token,
  caFirmId,
}: {
  data: CAFirmUpdateInputProp;
  token: string;
  caFirmId: string;
}) {
  try {
    const res = await fetcher(
      `caFirm/${caFirmId}`,
      {
        method: 'POST',
        body: data,
      },
      token
    );

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
